import request from '@/utils/request'

export function pageLiveTeacher(query) {
  return request({
    url: '/admin/livecourse/teacher/list',
    method: 'post',
    data: query
  })
}

export function getLiveTeacher(id) {
  return request({
    url: '/admin/livecourse/teacher/detail',
    method: 'post',
    params: { id }
  })
}

export function addLiveTeacher(data) {
  return request({
    url: '/admin/livecourse/teacher/add',
    method: 'post',
    data: data
  })
}

export function updateLiveTeacher(data) {
  return request({
    url: '/admin/livecourse/teacher/edit',
    method: 'post',
    data: data
  })
}

export function delLiveTeacher(id) {
  return request({
    url: '/admin/livecourse/teacher/delete',
    method: 'post',
    params: { id }
  })
}

export function listAllLiveTeacher() {
  return request({
    url: '/admin/livecourse/teacher/all',
    method: 'post'
  })
}
